export default [
  {
    "id": "mat-enem-0216",
    "numero": 1716,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Nosso calendário atual é embasado no antigo \ncalendário romano, que, por sua vez, tinha co-\nmo base as fases da lua. Os meses de janeiro, \nmarço, maio, julho, agosto, outubro e dezembro \npossuem 31 dias, e os demais, com exceção de \nfevereiro, possuem 30 dias. O dia 31 de março \nde certo ano ocorreu em uma terça-feira.  \n \nNesse mesmo ano, qual dia da semana será o \ndia 12 de outubro?  \n \nA) Domingo.  \nB) Segunda-feira.  \nC) Terça-feira.  \nD) Quinta-feira.  \nE) Sexta-feira.",
    "alternativas": {
      "D": "Quinta-feira.",
      "E": "Sexta-feira.",
      "A": "Domingo.",
      "B": "Segunda-feira."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 216,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0217",
    "numero": 1717,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Uma fábrica de tubos acondiciona tubos cilíndri-\ncos menores dentro de outros tubos cilíndricos. \nA figura mostra uma situação em que quatro \ntubos cilíndricos estão acondicionados perfeita-\nmente em um tubo com raio maior \n \n \n \nSuponha que você seja o operador da máquina \nque produzirá os tubos maiores em que serão \ncolocados, sem ajustes ou folgas, quatro tubos \ncilíndricos internos. Se o raio da base de cada \num dos cilindros menores for igual a 6 cm, a \nmáquina por você operada deverá ser ajustada \npara produzir tubos maiores, com raio da base \nigual a: \n \nA) 12 cm \nB) 12√2 cm \nC) 24√2 cm \nD) 6 (1 + √2) cm \nE) 12 (1 +√2) cm",
    "alternativas": {
      "D": "6 (1 + √2) cm",
      "E": "12 (1 +√2) cm",
      "A": "12 cm",
      "B": "12√2 cm"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 217,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0218",
    "numero": 1718,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Um fabricante de creme de leite comercializa \nseu produto em embalagens cilíndricas de diâ-\nmetro da base medindo 4 cm e altura 13,5 cm. \nO rótulo de cada uma custa R$ 0,60. Esse fabri-\ncante comercializará o referido produto em em-\nbalagens ainda cilíndricas de mesma capacida-\nde, mas com a medida do diâmetro da base \nigual à da altura. \nLevando-se em consideração exclusivamente o \ngasto com o rótulo, o valor que o fabricante \ndeverá pagar por esse rótulo é de: \n  \nA) R$ 0,20, pois haverá uma redução de 2/3 na \nsuperfície da embalagem coberta pelo rótulo.  \nB) R$ 0,40, pois haverá uma redução de 1/3 na \nsuperfície da embalagem coberta pelo rótulo.  \nC) R$ 0,60, pois não haverá alteração na capa-\ncidade da embalagem.  \nD) R$ 0,80, pois haverá um aumento de 1/3 na \nsuperfície da embalagem coberta pelo rótulo.  \nE) R$ 1,00, pois haverá um aumento de 2/3 na \nsuperfície da embalagem coberta pelo rótulo.",
    "alternativas": {
      "A": "R$ 0,20, pois haverá uma redução de 2/3 na superfície da embalagem coberta pelo rótulo.",
      "B": "R$ 0,40, pois haverá uma redução de 1/3 na superfície da embalagem coberta pelo rótulo.",
      "C": "R$ 0,60, pois não haverá alteração na capa- cidade da embalagem.",
      "E": "R$ 1,00, pois haverá um aumento de 2/3 na superfície da embalagem coberta pelo rótulo."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 218,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0219",
    "numero": 1719,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Para dificultar o trabalho de falsificadores, foi \nlançada uma nova família de cédulas do real. \nCom tamanho variável – quanto maior o valor, \nmaior a nota – o dinheiro novo terá vários ele-\nmentos de segurança. A estreia será entre abril \ne maio, quando começam a circular as notas de \nR$50,00 e R$100,00.  \n \nAs cédulas atuais têm 14 cm de comprimento e \n6,5 cm de largura. A maior cédula será a de \nR$100,00, com 1,6 cm a mais no comprimento e \n0,5 cm maior na largura. Quais serão as dimen-\nsões da nova nota de R$100,00?  \n \nA) 15,6 cm de comprimento e 6 cm de largura.  \nB) 15,6 cm de comprimento e 6,5 cm de largura.  \nC) 15,6 cm de comprimento e 7 cm de largura.  \nD) 15,9 cm de comprimento e 6,5 cm de largura.  \nE) 15,9 cm de comprimento e 7 cm de largura.",
    "alternativas": {
      "A": "15,6 cm de comprimento e 6 cm de largura.",
      "B": "15,6 cm de comprimento e 6,5 cm de largura.",
      "C": "15,6 cm de comprimento e 7 cm de largura.",
      "D": "15,9 cm de comprimento e 6,5 cm de largura."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 219,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0220",
    "numero": 1720,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Considere que um professor de arqueologia \ntenha obtido recursos para visitar 5 museus, \nsendo 3 deles no Brasil e 2 fora do país. Ele \ndecidiu restringir sua escolha aos museus naci-\nonais e internacionais relacionados na tabela a \nseguir. \n \n \n \nDe acordo com os recursos obtidos, de quantas \nmaneiras diferentes esse professor pode esco-\nlher os 5 museus para visitar?  \n \nA) 6  \nB) 8  \nC) 20  \nD) 24  \nE) 36",
    "alternativas": {
      "C": "20",
      "D": "24",
      "E": "36",
      "B": "8"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 220,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0221",
    "numero": 1721,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Certo município brasileiro cobra a conta de água \nde seus habitantes de acordo com o gráfico. O \nvalor a ser pago depende do consumo mensal \nem m3. \n \n \n \nSe um morador pagar uma conta de R$ 19,00, \nisso significa que ele consumiu:  \n \nA) 16 m3 de água.  \nB) 17 m3 de água.  \nC) 18 m3 de água.  \nD) 19 m3 de água.  \nE) 20 m3 de água.",
    "alternativas": {
      "E": "20 m3 de água.",
      "A": "16 m3 de água.",
      "B": "17 m3 de água.",
      "D": "19 m3 de água."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 221,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0222",
    "numero": 1722,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Certa marca de suco é vendida no mercado em \nembalagens tradicionais de forma cilíndrica. \nRelançando a marca, o fabricante pôs à venda \nembalagens menores, reduzindo a embalagem \ntradicional à terça parte de sua capacidade.  \n \nPor questões operacionais, a fábrica que forne-\nce as embalagens manteve a mesma forma, \nporém reduziu à metade o valor do raio da base \nda embalagem tradicional na construção da \nnova embalagem. Para atender à solicitação de \nredução da capacidade, após a redução no raio, \nfoi necessário determinar a altura da nova em-\nbalagem.  \n \nQue expressão relaciona a medida da altura da \nnova embalagem de suco (a) com a altura da \nembalagem tradicional (h)?   \n \nA) a = \nℎ\n12 \n \nB) a = \nℎ\n6 \n \nC) a = \n2ℎ\n3  \n \nD) a = \n4ℎ\n3  \n \nE) a = \n4ℎ\n9",
    "alternativas": {
      "E": "a = 4ℎ 9",
      "A": "a = ℎ 12",
      "B": "a = ℎ 6",
      "D": "a = 4ℎ 3"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 222,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0223",
    "numero": 1723,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Um dos estádios mais bonitos da Copa do Mun-\ndo na África do Sul é o Green Point, situado na \nCidade do Cabo, com capacidade para 68000 \npessoas. \n \nEm certa partida, o estádio estava com 95% de \nsua capacidade, sendo que 487 pessoas não \npagaram o ingresso que custava 150 dólares \ncada. A expressão que representa o valor arre-\ncada nesse jogo, em dólares, é: \n \nA) 0,95 x 68000 X 150 - 487 \nB) 0,95 x (68000 - 487) x 150 \nC) (0,95 x 68000 - 487) x 150 \nD) 95 x (68000 - 487) x 150 \nE) (95 X 68000 - 487) x 150",
    "alternativas": {
      "A": "0,95 x 68000 X 150 - 487",
      "B": "0,95 x (68000 - 487) x 150",
      "C": "(0,95 x 68000 - 487) x 150",
      "E": "(95 X 68000 - 487) x 150"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 223,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0224",
    "numero": 1724,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Lucas precisa estacionar o carro pelo período \nde 40 minutos, e sua irmã Clara também precisa \nestacionar o carro pelo período de 6 horas. O \nestacionamento Verde cobra R$ 5,00 por hora \nde permanência.  \n \nO estacionamento Amarelo cobra R$ 6,00 por 4 \nhoras de permanência e mais R$ 2,50 por hora \nou fração de hora ultrapassada. O estaciona-\nmento Preto cobra R$ 7,00 por 3 horas de per-\nmanência e mais R$ 1,00 por hora ou fração de \nhora ultrapassada.  \n \nOs estacionamentos mais econômicos para \nLucas e Clara, respectivamente, são:  \n \nA) Verde e Preto.  \nB) Verde e Amarelo.  \nC) Amarelo e Amarelo.  \nD) Preto e Preto.  \nE) Verde e Verde.",
    "alternativas": {
      "D": "Preto e Preto.",
      "A": "Verde e Preto.",
      "B": "Verde e Amarelo.",
      "C": "Amarelo e Amarelo."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 224,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0225",
    "numero": 1725,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Em março de 2010, o Conselho Nacional de \nDesenvolvimento \nCientífico \ne \nTecnológico \n(CNPq) reajustou os valores de bolsas de estu-\ndo concedidas a alunos de iniciação científica, \nque passaram a receber R$ 360,00 mensais, \num aumento de 20% com relação ao que era \npago até então. O órgão concedia 29 mil bolsas \nde iniciação científica até 2009, e esse número \naumentou em 48% em 2010. \n \nCaso o CNPq decidisse não aumentar o valor \ndos pagamentos dos bolsistas, utilizando o \nmontante destinado a tal aumento para incre-\nmentar ainda mais o número de bolsas de inici-\nação científica no país, quantas bolsas a mais \nque em 2009, aproximadamente, poderiam ser \noferecidas em 2010?  \nA) 5,8 mil.  \nB) 13,9 mil.  \nC) 22,5 mil.  \nD) 51,5 mil.  \nE) 94,4 mil.",
    "alternativas": {
      "E": "94,4 mil.",
      "B": "13,9 mil.",
      "C": "22,5 mil.",
      "D": "51,5 mil."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2010.2",
    "numeroOriginal": 225,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0226",
    "numero": 1726,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "O dono de uma oficina mecânica precisa de um \npistão das partes de um motor, de 68 mm de \ndiâmetro, para o conserto de um carro. Para \nconseguir um, esse dono vai até um ferro-velho \ne lá encontra pistões com diâmetros iguais a \n68,21 mm; 68,102 mm; 68,001 mm; 68,02 mm e \n68,012 mm. Para colocar o pistão no motor que \nestá sendo consertado, o dono da oficina terá \nde adquirir aquele que tenha o diâmetro mais \npróximo do que precisa. \n \nNessa condição, o dono da oficina deverá com-\nprar o pistão de diâmetro: \n \nA) 68,21 mm. \nB) 68,102 mm. \nC) 68,02 mm. \nD) 68,012 mm. \nE) 68,001 mm.",
    "alternativas": {
      "D": "68,012 mm.",
      "E": "68,001 mm.",
      "A": "68,21 mm.",
      "C": "68,02 mm."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 226,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0227",
    "numero": 1727,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "A Escala e Magnitude de Momento (abreviada \ncomo MMS e denotada como MW), introduzida \nem 1979 por Thomas Haks e Hiroo Kanamori, \nsubstituiu a Escala de Richter para medir a \nmagnitude dos terremotos em termos de ener-\ngia liberada. Menos conhecida pelo público, a \nMMS é, no entanto, a escala usada para estimar \nas magnitudes de todos os grandes terremotos \nda atualidade. Assim como a escala Richter, a \nMMS é uma escala logarítmica. MW e M0 se \nrelacionam pela fórmula: \n \n \n \nOnde M0 é o momento sísmico (usualmente \nestimado a partir dos registros de movimento da \nsuperfície, através dos sismogramas), cuja uni-\ndade é o dina ⋅ cm.  \n \nO terremoto de Kobe, acontecido no dia 17 de \njaneiro de 1995, foi um dos terremotos que cau-\nsaram maior impacto no Japão e na comunida-\nde científica internacional. Teve magnitude MW = \n7,3. \n \nMostrando que é possível determinar a medida \npor meio de conhecimentos matemáticos, qual \nfoi o momento sísmico M0 do terremoto de Kobe \n(em dina ⋅ cm)? \nA) 10-5,10 \nB) 10-0,73 \nC) 1012,00 \nD) 1021,65 \nE) 1027,00",
    "alternativas": {
      "E": "1027,00",
      "A": "10-5,10",
      "B": "10-0,73",
      "D": "1021,65"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 227,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0228",
    "numero": 1728,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "Um mecânico de uma equipe de corrida neces-\nsita que as seguintes medidas realizadas em \num carro sejam obtidas em metros: \n \na) distância a entre os eixos dianteiro e traseiro; \nb) altura b entre o solo e o encosto do piloto. \n \n \n \nAo optar pelas medidas a e b em metros, ob-\ntêm-se, respectivamente, \n \nA) 0,23 e 0,16. \nB) 2,3 e 1,6. \nC) 23 e 16. \nD) 230 e 160. \nE) 2300 e 1600.",
    "alternativas": {
      "C": "23 e 16.",
      "E": "2300 e 1600.",
      "A": "0,23 e 0,16.",
      "B": "2,3 e 1,6."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 228,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0229",
    "numero": 1729,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "O medidor de energia elétrica de uma residên-\ncia, conhecido por “relógio de luz”, é constituído \nde quatro pequenos relógios, cujos sentidos de \nrotação estão indicados conforme a figura: \n \n \n \nA medida é expressa em kWh. O número obtido \nna leitura é composto por 4 algarismos. Cada \nposição do número é formada pelo último alga-\nrismo ultrapassado pelo ponteiro. O número \nobtido pela leitura em kWh, na imagem, é: \n \nA) 2614. \nB) 3624. \nC) 2715. \nD) 3725. \nE) 4162.",
    "alternativas": {
      "A": "2614.",
      "B": "3624.",
      "C": "2715.",
      "D": "3725."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 229,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0230",
    "numero": 1730,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "Em uma certa cidade, os moradores de um bair-\nro carente de espaços de lazer reivindicam à \nprefeitura municipal a construção de uma praça. \nA prefeitura concorda com a solicitação e afirma \nque irá construí-la em formato retangular devido \nàs características técnicas do terreno. Restri-\nções de natureza orçamentária impõem que \nsejam gastos, no máximo, 180 m de tela para \ncercar a praça. A prefeitura apresenta aos mo-\nradores desse bairro as medidas dos terrenos \ndisponíveis para a construção da praça: \n \nTerreno 1: 55 m por 45 m \nTerreno 2: 55 m por 55 m \nTerreno 3: 60 m por 30 m \nTerreno 4: 70 m por 20 m \nTerreno 5: 95 m por 85 m \n \nPara optar pelo terreno de maior área, que \natenda às restrições impostas pela prefeitura, os \nmoradores deverão escolher o terreno.  \n \nA) 1 \nB) 2 \nC) 3 \nD) 4 \nE) 5",
    "alternativas": {
      "B": "2",
      "C": "3",
      "D": "4",
      "E": "5"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 230,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0231",
    "numero": 1731,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "Você pode adaptar as atividades do seu dia a \ndia de uma forma que possa queimar mais calo-\nrias do que as gastas normalmente, conforme a \nrelação seguinte: \n \n– Enquanto você fala ao telefone, faça agacha-\nmentos: 100 calorias gastas em 20 minutos. \n– Meia hora de supermercado: 100 calorias. \n– Cuidar do jardim por 30 minutos: 200 calorias. \n– Passear com o cachorro: 200 calorias em 30 \nminutos. \n– Tirar o pó dos móveis: 150 calorias em 30 \nminutos. \n– Lavar roupas por 30 minutos: 200 calorias. \n \nUma pessoa deseja executar essas atividades, \nporém, ajustando o tempo para que, em cada \numa, gaste igualmente 200 calorias. A partir dos \najustes, quanto tempo a mais será necessário \npara realizar todas as atividades? \n \nA) 50 minutos. \nB) 60 minutos. \nC) 80 minutos. \nD) 120 minutos. \nE) 170 minutos.",
    "alternativas": {
      "B": "60 minutos.",
      "D": "120 minutos.",
      "E": "170 minutos.",
      "A": "50 minutos."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 231,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0232",
    "numero": 1732,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "Uma equipe de especialistas do centro meteoro-\nlógico de uma cidade mediu a temperatura do \nambiente, sempre no mesmo horário, durante \n15 dias intercalados, a partir do primeiro dia de \num mês. Esse tipo de procedimento é frequente, \numa vez que os dados coletados servem de \nreferência para estudos e verificação de ten-\ndências climáticas ao longo dos meses e anos. \nAs medições ocorridas nesse período estão \nindicadas no quadro: \n \n \n \nEm relação à temperatura, os valores da média, \nmediana e moda são, respectivamente, iguais a: \n \nA) 17°C, 17°C e 13,5°C. \nB) 17°C, 18°C e 13,5°C. \nC) 17°C, 13,5°C e 18°C. \nD) 17°C, 18°C e 21,5°C. \nE) 17°C, 13,5°C e 21,5°C.",
    "alternativas": {
      "D": "17°C, 18°C e 21,5°C.",
      "E": "17°C, 13,5°C e 21,5°C.",
      "A": "17°C, 17°C e 13,5°C.",
      "B": "17°C, 18°C e 13,5°C."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 232,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0233",
    "numero": 1733,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "Para uma atividade realizada no laboratório de \nMatemática, um aluno precisa construir uma \nmaquete da quadra de esportes da escola que \ntem 28 m de comprimento por 12 m de largura. \nA maquete deverá ser construída na escala de \n1:250. \n \nQue medidas de comprimento e largura, em cm, \no aluno utilizará na construção da maquete? \n \nA) 4,8 e 11,2 \nB) 7,0 e 3,0 \nC) 11,2 e 4,8 \nD) 28,0 e 12,0 \nE) 30,0 e 70,0",
    "alternativas": {
      "C": "11,2 e 4,8",
      "E": "30,0 e 70,0",
      "A": "4,8 e 11,2",
      "B": "7,0 e 3,0"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 233,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0234",
    "numero": 1734,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "Uma indústria fabrica brindes promocionais em \nforma de pirâmide. A pirâmide é obtida a partir \nde quatro cortes em um sólido que tem a forma \nde um cubo. No esquema, estão indicados o \nsólido original (cubo) e a pirâmide obtida a partir \ndele. \n \n \nOs pontos A, B, C, D e O do cubo e da pirâmide \nsão os mesmos. O ponto O é central na face \nsuperior do cubo. Os quatro cortes saem de O \nem direção às arestas AD\n̅̅̅̅, BC\n̅̅̅̅, AB\n̅̅̅̅ e CD\n̅̅̅̅, nessa \nordem. Após os cortes, são descartados quatro \nsólidos. \n \nOs formatos dos sólidos descartados são \n \nA) todos iguais. \nB) todos diferentes. \nC) três iguais e um diferente. \nD) apenas dois iguais. \nE) iguais dois a dois.",
    "alternativas": {
      "D": "apenas dois iguais.",
      "E": "iguais dois a dois.",
      "B": "todos diferentes.",
      "C": "três iguais e um diferente."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 234,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0235",
    "numero": 1735,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "Considere que a xícara citada na notícia seja \nequivalente a, aproximadamente, 120 mL de \ncafé. Suponha que em 2010 os brasileiros be-\nbam ainda mais café, aumentando o consumo \nem 1/5 do que foi consumido no ano anterior. \n \nDe acordo com essas informações, qual a pre-\nvisão mais aproximada para o consumo de café \nem 2010? \n \nA) 8 bilhões de litros. \nB) 16 bilhões de litros. \nC) 32 bilhões de litros. \nD) 40 bilhões de litros. \nE) 48 bilhões de litros.",
    "alternativas": {
      "E": "48 bilhões de litros.",
      "B": "16 bilhões de litros.",
      "C": "32 bilhões de litros.",
      "D": "40 bilhões de litros."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 235,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0236",
    "numero": 1736,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "Sabe-se que a distância real, em linha reta, de \numa cidade A, localizada no estado de São \nPaulo, a uma cidade B, localizada no estado de \nAlagoas, é igual a 2000 km. Um estudante, ao \nanalisar um mapa, verificou com sua régua que \na distância entre essas duas cidades, A e B, era \n8 cm. \n \nOs dados nos indicam que o mapa observado \npelo estudante está na escala de: \n \nA) 1 : 250. \nB) 1 : 2500. \nC) 1 : 25000. \nD) 1 : 250000. \nE) 1 : 25000000.",
    "alternativas": {
      "A": "1 : 250.",
      "C": "1 : 25000.",
      "D": "1 : 250000.",
      "E": "1 : 25000000."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 236,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0237",
    "numero": 1737,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "A figura seguinte mostra um modelo de sombri-\nnha muito usado em países orientais. \n \n \n \nEsta figura é uma representação de uma super-\nfície de revolução chamada de: \n \nA) pirâmide. \nB) semiesfera. \nC) cilindro. \nD) tronco de cone. \nE) cone.",
    "alternativas": {
      "B": "semiesfera.",
      "D": "tronco de cone.",
      "E": "cone.",
      "A": "pirâmide."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 237,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0238",
    "numero": 1738,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "Em 2010, um caos aéreo afetou o continente \neuropeu, devido à quantidade de fumaça expe-\nlida por um vulcão na Islândia, o que levou ao \ncancelamento de inúmeros voos. Cinco dias \napós o início desse caos, todo o espaço aéreo \neuropeu acima de 6000 metros estava liberado, \ncom exceção do espaço aéreo da Finlândia. Lá, \napenas voos internacionais acima de 31 mil pés \nestavam liberados. \n \nConsidere que 1 metro equivale a aproximada-\nmente 3,3 pés. Qual a diferença, em pés, entre \nas altitudes liberadas na Finlândia e no restante \ndo continente europeu cinco dias após o início \ndo caos? \n \nA) 3390 pés. \nB) 9390 pés. \nC) 11200 pés. \nD) 19800 pés. \nE) 50800 pés.",
    "alternativas": {
      "E": "50800 pés.",
      "A": "3390 pés.",
      "B": "9390 pés.",
      "C": "11200 pés."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 238,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0239",
    "numero": 1739,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "O Índice de Massa Corporal (IMC) é largamente \nutilizado há cerca de 200 anos, mas esse cálcu-\nlo representa muito mais a corpulência que a \nadiposidade, uma vez que indivíduos musculo-\nsos e obesos podem apresentar o mesmo IMC. \nUma nova pesquisa aponta o Índice de Adiposi-\ndade Corporal (IAC) como uma alternativa mais \nfidedigna para quantificar a gordura corporal, \nutilizando a medida do quadril e a altura. A figu-\nra mostra como calcular essas medidas, saben-\ndo-se que, em mulheres, a adiposidade normal \nestá entre 19% e 26%. \n \n \nUma jovem com IMC = 20 kg/m2, 100 cm de \ncircunferência dos quadris e 60 kg de massa \ncorpórea resolveu averiguar seu IAC. Para se \nenquadrar aos níveis de normalidade de gordu-\nra corporal, a atitude adequada que essa jovem \ndeve ter diante da nova medida é: \n \n(Use √3 = 1,7 e √1,7 = 1,3) \n \nA) reduzir seu excesso de gordura em cerca de \n1%. \nB) reduzir seu excesso de gordura em cerca de \n27%. \nC) manter seus níveis atuais de gordura. \nD) aumentar seu nível de gordura em cerca de \n1%. \nE) aumentar seu nível de gordura em cerca de \n27%.",
    "alternativas": {
      "C": "manter seus níveis atuais de gordura.",
      "D": "aumentar seu nível de gordura em cerca de 1%.",
      "A": "reduzir seu excesso de gordura em cerca de 1%.",
      "B": "reduzir seu excesso de gordura em cerca de 27%."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 239,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0240",
    "numero": 1740,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "Um bairro de uma cidade foi planejado em uma \nregião plana, com ruas paralelas e perpendicu-\nlares, delimitando quadras de mesmo tamanho. \nNo plano de coordenadas cartesianas seguinte, \nesse bairro localiza-se no segundo quadrante, e \nas distâncias nos eixos são dadas em quilôme-\ntros. \nA reta de equação y = x + 4 representa o plane-\njamento do percurso da linha do metrô subter-\nrâneo que atravessará o bairro e outras regiões \nda cidade. No ponto P = (–5, 5), localiza-se um \nhospital público.  \n \nA comunidade solicitou ao comitê de planeja-\nmento que fosse prevista uma estação do metrô \nde modo que sua distância ao hospital, medida \nem linha reta, não fosse maior que 5 km. \n \nAtendendo ao pedido da comunidade, o comitê \nargumentou corretamente que isso seria auto-\nmaticamente satisfeito, pois já estava prevista a \nconstrução de uma estação no ponto: \n \nA) (–5, 0). \nB) (–3, 1). \nC) (–2, 1). \nD) (0, 4). \nE) (2, 6).",
    "alternativas": {
      "E": "(2, 6).",
      "B": "(–3, 1).",
      "C": "(–2, 1).",
      "D": "(0, 4)."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 240,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0241",
    "numero": 1741,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "O polígono que dá forma a essa calçada é inva-\nriante por rotações, em torno de seu centro, de: \n \nA) 45°. \nB) 60°. \nC) 90°. \nD) 120°. \nE) 180°.",
    "alternativas": {
      "D": "120°.",
      "E": "180°.",
      "A": "45°.",
      "C": "90°."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 241,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0243",
    "numero": 1743,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "Observe as dicas para calcular a quantidade \ncerta de alimentos e bebidas para as festas de \nfim de ano: \n \n- Para o prato principal, estime 250 gramas de \ncarne para cada pessoa. \n- Um copo americano cheio de arroz rende o \nsuficiente para quatro pessoas. \n- Para a farofa, calcule quatro colheres de sopa \npor convidado. \n- Uma garrafa de vinho serve seis pessoas. \n- Uma garrafa de cerveja serve duas. \n- Uma garrafa de espumante serve três convi-\ndados. \n \nQuem organiza festas faz esses cálculos em \ncima do total de convidados, independente do \ngosto de cada um. Um anfitrião decidiu seguir \nessas dicas ao se preparar para receber 30 \nconvidados para a ceia de Natal. Para seguir \nessas orientações à risca, o anfitrião deverá \ndispor de: \n \nA) 120 kg de carne, 7 copos americanos e meio de \narroz, 120 colheres de sopa de farofa, 5 garrafas \nde vinho, 15 de cerveja e 10 de espumante. \nB) 120 kg de carne, 7 copos americanos e meio de \narroz, 120 colheres de sopa de farofa, 5 garrafas \nde vinho, 30 de cerveja e 10 de espumante. \nC) 75 kg de carne, 7 copos americanos e meio de \narroz, 120 colheres de sopa de farofa, 5 garrafas \nde vinho, 15 de cerveja e 10 de espumante. \nD) 7,5 kg de carne, 7 copos americanos, 120 co-\nlheres de sopa de farofa, 5 garrafas de vinho, 30 \nde cerveja e 10 de espumante. \nE) 7,5 kg de carne, 7 copos americanos e meio de \narroz, 120 colheres de sopa de farofa, 5 garrafas \nde vinho, 15 de cerveja e 10 de espumante.",
    "alternativas": {
      "E": "7,5 kg de carne, 7 copos americanos e meio de arroz, 120 colheres de sopa de farofa, 5 garrafas de vinho, 15 de cerveja e 10 de espumante.",
      "A": "120 kg de carne, 7 copos americanos e meio de arroz, 120 colheres de sopa de farofa, 5 garrafas de vinho, 15 de cerveja e 10 de espumante.",
      "B": "120 kg de carne, 7 copos americanos e meio de arroz, 120 colheres de sopa de farofa, 5 garrafas de vinho, 30 de cerveja e 10 de espumante.",
      "C": "75 kg de carne, 7 copos americanos e meio de arroz, 120 colheres de sopa de farofa, 5 garrafas de vinho, 15 de cerveja e 10 de espumante."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 243,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0244",
    "numero": 1744,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "A participação dos estudantes na Olimpíada \nBrasileira de Matemática das Escolas Públicas \n(OBMEP) aumenta a cada ano. O quadro indica \no percentual de medalhistas de ouro, por região, \nnas edições da OBMEP de 2005 a 2009: \n \n \n \nEm relação às edições de 2005 a 2009 da OB-\nMEP, qual o percentual médio de medalhistas \nde ouro da região Nordeste? \n \nA) 14,6% \nB) 18,2% \nC) 18,4% \nD) 19,0% \nE) 21,0%",
    "alternativas": {
      "B": "18,2%",
      "C": "18,4%",
      "D": "19,0%",
      "A": "14,6%"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 244,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0245",
    "numero": 1745,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "Para determinar a distância de um barco até a \npraia, um navegante utilizou o seguinte proce-\ndimento: a partir de um ponto A, mediu o ângulo \nvisual αα fazendo mira em um ponto fixo P da \npraia. Mantendo o barco no mesmo sentido, ele \nseguiu até um ponto B de modo que fosse pos-\nsível ver o mesmo ponto P da praia, no entanto \nsob um ângulo visual 2α. A figura ilustra essa \nsituação: \n \n \nSuponha que o navegante tenha medido o ân-\ngulo α = 30º e, ao chegar ao ponto B, verificou \nque o barco havia percorrido a distância AB = \n2000 m. Com base nesses dados e mantendo a \nmesma trajetória, a menor distância do barco \naté o ponto fixo P será: \n \nA) 1000 m. \n \nB) 1000√3 m. \n \nC) 2000√3\n3  m. \n \nD) 2000 m. \n \nE) 2000√3 m.",
    "alternativas": {
      "B": "1000√3 m.",
      "C": "2000√3 3 m.",
      "D": "2000 m.",
      "E": "2000√3 m."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 245,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0246",
    "numero": 1746,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "O saldo de contratações no mercado formal no \nsetor varejista da região metropolitana de São \nPaulo registrou alta. Comparando as contrata-\nções deste setor no mês de fevereiro com as de \njaneiro deste ano, houve incremento de 4 300 \nvagas no setor, totalizando 880 605 trabalhado-\nres com carteira assinada. \n \nSuponha que o incremento de trabalhadores no \nsetor varejista seja sempre o mesmo nos seis \nprimeiros meses do ano.   \n \nConsiderando-se que y e x representam, res-\npectivamente, as quantidades de trabalhadores \nno setor varejista e os meses, janeiro sendo o \nprimeiro, fevereiro, o segundo, e assim por dian-\nte, a expressão algébrica que relaciona essas \nquantidades nesses meses é: \n \nA) y = 4300x \nB) y = 884905x \nC) y = 872005 + 4300x \nD) y = 876305 + 4300x \nE) y = 880605 + 4300x",
    "alternativas": {
      "A": "y = 4300x",
      "C": "y = 872005 + 4300x",
      "D": "y = 876305 + 4300x",
      "E": "y = 880605 + 4300x"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 246,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0247",
    "numero": 1747,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "Um jovem investidor precisa escolher qual in-\nvestimento lhe trará maior retorno financeiro em \numa aplicação de R$ 500,00. Para isso, pesqui-\nsa o rendimento e o imposto a ser pago em dois \ninvestimentos: poupança e CDB (certificado de \ndepósito bancário). As informações obtidas es-\ntão resumidas no quadro: \n \n \n \nPara o jovem investidor, ao final de um mês, a \naplicação mais vantajosa é: \n \nA) a poupança, pois totalizará um montante de \nR$502,80. \nB) a poupança, pois totalizará um montante de \nR$500,56. \nC) o CDB, pois totalizará um montante de \nR$504,38. \nD) o CDB, pois totalizará um montante de \nR$504,21. \nE) o CDB, pois totalizará um montante de \nR$500,87.",
    "alternativas": {
      "A": "a poupança, pois totalizará um montante de R$502,80.",
      "B": "a poupança, pois totalizará um montante de R$500,56.",
      "D": "o CDB, pois totalizará um montante de R$504,21.",
      "E": "o CDB, pois totalizará um montante de R$500,87."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 247,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0248",
    "numero": 1748,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "A tabela compara o consumo mensal, em kWh, \ndos consumidores residenciais e dos de baixa \nrenda, antes e depois da redução da tarifa de \nenergia no estado de Pernambuco. \n \n \n \nConsidere dois consumidores: um que é de \nbaixa renda e gastou 100 kWh e outro do tipo \nresidencial que gastou 185 kWh. A diferença \nentre o gasto desses consumidores com 1 kWh, \ndepois da redução da tarifa de energia, mais \naproximada, é de: \n \nA) R$ 0,27. \nB) R$ 0,29. \nC) R$ 0,32. \nD) R$ 0,34. \nE) R$ 0,61.",
    "alternativas": {
      "C": "R$ 0,32.",
      "E": "R$ 0,61.",
      "A": "R$ 0,27.",
      "B": "R$ 0,29."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 248,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0249",
    "numero": 1749,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "O prefeito de uma cidade deseja construir uma \nrodovia para dar acesso a outro município. Para \nisso, foi aberta uma licitação na qual concorre-\nram duas empresas. A primeira cobrou R$ 100 \n000,00 por km construído (n), acrescidos de um \nvalor fixo de R$ 350 000,00, enquanto a segun-\nda cobrou R$ 120 000,00 por km construído (n), \nacrescidos de um valor fixo de R$ 150 000,00.  \n \nAs duas empresas apresentam o mesmo pa-\ndrão de qualidade dos serviços prestados, mas \napenas uma delas poderá ser contratada. \n \nDo ponto de vista econômico, qual equação \npossibilitaria encontrar a extensão da rodovia \nque tornaria indiferente para a prefeitura esco-\nlher qualquer uma das propostas apresentadas? \n \nA) 100n + 350 = 120n + 150 \nB) 100n + 150 = 120n + 350 \nC) 100(n + 350) = 120(n + 150) \nD) 100(n + 350 000) = 120(n + 150 000) \nE) 350(n + 100 000) = 150(n + 120 000)",
    "alternativas": {
      "A": "100n + 350 = 120n + 150",
      "B": "100n + 150 = 120n + 350",
      "C": "100(n + 350) = 120(n + 150)",
      "D": "100(n + 350 000) = 120(n + 150 000)"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 249,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0250",
    "numero": 1750,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "Uma pessoa aplicou certa quantia em ações. No \nprimeiro mês, ela perdeu 30% do total do inves-\ntimento e, no segundo mês, recuperou 20% do \nque havia perdido. Depois desses dois meses, \nresolveu tirar o montante de R$ 3.800,00 gerado \npela aplicação. \n \nA quantia inicial que essa pessoa aplicou em \nações corresponde ao valor de: \n \nA) R$4.222,22. \nB) R$4.523,80. \nC) R$5.000,00. \nD) R$13.300,00. \nE) R$17.100,00.",
    "alternativas": {
      "B": "R$4.523,80.",
      "C": "R$5.000,00.",
      "D": "R$13.300,00.",
      "E": "R$17.100,00."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 250,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0251",
    "numero": 1751,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "Cerca de 20 milhões de brasileiros vivem na \nregião coberta pela caatinga, em quase 800 mil \nkm2 de área. Quando não chove, o homem do \nsertão e sua família precisam caminhar quilôme-\ntros em busca da água dos açudes. A irregulari-\ndade climática é um dos fatores que mais inter-\nferem na vida do sertanejo. \n \nSegundo este levantamento, a densidade de-\nmográfica da região coberta pela caatinga, em \nhabitantes por km2, é de: \n \nA) 250. \nB) 25. \nC) 2,5. \nD) 0,25. \nE) 0,025.",
    "alternativas": {
      "B": "25.",
      "D": "0,25.",
      "E": "0,025.",
      "A": "250."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 251,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0252",
    "numero": 1752,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "O número mensal de passagens de uma deter-\nminada empresa aérea aumentou no ano pas-\nsado nas seguintes condições: em janeiro foram \nvendidas 33000 passagens; em fevereiro, \n34500; em março, 36000. Esse padrão de cres-\ncimento se mantém para os meses subsequen-\ntes. \nQuantas passagens foram vendidas por essa \nempresa em julho do ano passado? \n \nA) 38 000 \nB) 40 500 \nC) 41 000 \nD) 42 000 \nE) 48 000",
    "alternativas": {
      "B": "40 500",
      "D": "42 000",
      "E": "48 000",
      "A": "38 000"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 252,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0253",
    "numero": 1753,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "Rafael mora no Centro de uma cidade e decidiu se mudar, por recomendações médicas, para uma das \nregiões: Rural, Comercial, Residencial Urbano ou Residencial Suburbano. A principal recomendação \nmédica foi com as temperaturas das “ilhas de calor” da região, que deveriam ser inferiores a 31ºC. Tais \ntemperaturas são apresentadas por gráfico: \n \n \n \nEscolhendo, aleatoriamente, uma das outras regiões para morar, a probabilidade de ele escolher uma \nregião que seja adequada às recomendações médicas é: \n \nA) 1/4 \nB) 1/4 \nC) 2/5 \nD) 3/5 \nE) 3/4",
    "alternativas": {
      "B": "1/4",
      "C": "2/5",
      "E": "3/4",
      "A": "1/4"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 253,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0254",
    "numero": 1754,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "Muitas medidas podem ser tomadas em nossas \ncasas visando à utilização racional de energia \nelétrica. Isso deve ser uma atitude diária de \ncidadania. Uma delas pode ser a redução do \ntempo no banho. Um chuveiro com potência de \n4 800 W consome 4,8 kW por hora. \n \nUma pessoa que toma dois banhos diariamente, \nde 10 minutos cada, consumirá, em sete dias, \nquantos kW? \n \nA) 0,8 \nB) 1,6 \nC) 5,6 \nD) 11,2 \nE) 33,6",
    "alternativas": {
      "C": "5,6",
      "D": "11,2",
      "A": "0,8",
      "B": "1,6"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 254,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0255",
    "numero": 1755,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "O atletismo é um dos esportes que mais se \nidentificam com o espírito olímpico. A figura \nilustra uma pista de atletismo. A pista é compos-\nta por oito raias e tem largura de 9,76 m. \nAs raias são numeradas do centro da pista para \na extremidade e são construídas do centro da \npista para a extremidade e são construídas de \nsegmentos de retas paralelas e arcos de circun-\nferência. Os dois semicírculos da pista são \niguais. \n \nSe os atletas partissem do mesmo ponto, dando \numa volta completa, em qual das raias o corre-\ndor estaria sendo beneficiado? \n \nA) 1 \nB) 4 \nC) 5 \nD) 7 \nE) 8",
    "alternativas": {
      "D": "7",
      "E": "8",
      "A": "1",
      "C": "5"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 255,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0256",
    "numero": 1756,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "Nos últimos cinco anos, 32 mil mulheres de 20 a \n24 anos foram internadas nos hospitais do SUS \npor causa de AVC. Entre os homens da mesma \nfaixa etária, houve 28 mil internações pelo \nmesmo motivo. \n \nSuponha que, nos próximos cinco anos, haja \num acréscimo de 8 mil internações de mulheres \ne que o acréscimo de internações de homens \npor AVC ocorra na mesma proporção. De acor-\ndo com as informações dadas, o número de \nhomens que seriam internados por AVC, nos \npróximos cinco anos, corresponderia a: \n \nA) 4 mil. \nB) 9 mil. \nC) 21 mil. \nD) 35 mil. \nE) 39 mil.",
    "alternativas": {
      "C": "21 mil.",
      "D": "35 mil.",
      "E": "39 mil.",
      "A": "4 mil."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 256,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  }
];